import React from 'react';
import {
  Wrapper,
  Message
} from './styled';

const Error = ({ children }) => (
  <Wrapper>
    <Message>{children}</Message>
  </Wrapper>
);

export default Error;
